export function Location({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.99237 2.0625H9.00018C11.3194 2.06257 13.877 3.37434 14.6633 6.22363L14.7336 6.50391C15.5183 9.96586 13.4115 12.9761 11.3078 14.999L11.3049 15.002C10.6627 15.6257 9.83256 15.9375 9.00018 15.9375C8.16842 15.9375 7.33595 15.6266 6.68475 15V14.999C4.64718 13.0397 2.60548 10.1462 3.19354 6.81934L3.25897 6.49609C3.95036 3.45429 6.60397 2.06255 8.99237 2.0625ZM9.00018 4.62012C7.281 4.62012 5.88792 6.01324 5.88788 7.73242C5.88788 9.45164 7.28097 10.8447 9.00018 10.8447C10.7193 10.8446 12.1125 9.45158 12.1125 7.73242C12.1124 6.0133 10.7193 4.62021 9.00018 4.62012Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </svg>
    </span>
  );
}
